export const isMobileMode = () => window.runtimeConfig && window.runtimeConfig._env === 'dev' && window.innerWidth < 768
